export default "__VITE_ASSET__e06840dc__"